const permissions = {
  queryProvince:{name:"查询省份信息",code:"queryProvince"}
};
export default {
  permissions,
};



// WEBPACK FOOTER //
// ./src/http/permission.js